import { DateTime } from "luxon";
import { FilterParams } from "types/common";


export const formatTimeFromUtc = (time: string, format = "MM/dd/yy") => {
  if (!time) {
    return;
  }
  return DateTime.fromISO(time).toFormat(format);
};


export const jointIdList: {[key: string]: string} = {
  '62e190ff9f293b927973f92b': "Double knee drop",
  '624d97375ed2b030d38e4707': "Left knee drop",
  '624d97335ed2b030d38e4706': "Right knee drop"
}

export const getDayAndMonthFromUTC  = (time: string) => {
  if (!time) {
    return;
  }
  const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  let isoDate = DateTime.fromISO(time)
  let currentLabel = `${isoDate.day} ${ month[isoDate.month -1]}`;

  return currentLabel;
};
export function round(value:number, precision:number) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export const createDataset =(label:string, x:string | undefined, examResult:any, backgroundColor:string, stack:string, datalabel:string) =>{
  let y;
  if(label == 'Right Knee Min Value'){
    y = examResult.rightMinValue
  }
  else if(label == 'Right Knee Max Value'){
    if(examResult.rightMinValue >0){
      y = examResult.rightMaxValue - examResult.rightMinValue
    }
    else{
      y = examResult.rightMaxValue
    }
  }
  else if(label == 'Left Knee Min Value'){
    y = examResult.leftMinValue
  }
  else if(label == 'Left Knee Max Value'){
    if(examResult.leftMinValue >0){
      y = examResult.leftMaxValue - examResult.leftMinValue
    }
    else{
      y = examResult.leftMaxValue
    }
  }
  const dataset = {
    label: label,
    data: [
      {
        x: x,
        y: y,
      },
    ],
    borderColor: 'white',
    borderWidth: 1,
    borderSkipped: false,
    backgroundColor: backgroundColor,
    stack: stack,
    // borderSkipped: false,
    //borderRadius: 20,
    datalabels: {
      formatter: () => {
        return datalabel;
      }
    },
    tooltip: {
      displayColors: false,//to not show bar color in the tooltip
      callbacks: {
        label: function(tooltipItem: any) {
          let value;
          if(tooltipItem.datasetIndex%2 == 1 && tooltipItem.chart._sortedMetasets[tooltipItem.datasetIndex-1]._dataset.data[0].y > 0){//check if is max value and his min is positive
            value = tooltipItem.raw.y + tooltipItem.chart._sortedMetasets[tooltipItem.datasetIndex-1]._dataset.data[0].y
          }
          else{
            value = tooltipItem.raw.y
          }
          return tooltipItem.dataset.label+": "+round(value,1);
        }
      }
    }
  }
  return dataset
};

export const checkIfDatesAreTheSameDayIgnoringTime  = (date1: string,date2: string) => {
  if (!date1 || !date2) {
    return;
  }
  let isoDate1 = DateTime.fromISO(date1)
  let isoDate2 = DateTime.fromISO(date2)
  return  `${isoDate1.day} ${ isoDate1.month}` === `${isoDate2.day} ${isoDate2.month}`
};


export const getCheckedFilterParams = (
  filterParams: FilterParams[]
): Array<Record<string, string>> => {
  return filterParams
    .filter((filterParam) => filterParam.checked)
    .map((filterParam) => ({ [filterParam.filterKey]: filterParam.id }));
};

// [{jointId: '', side: ''}, {jointId: '', side: ''}] => {jointId='ww,'}
export const formatFilterParamsArray = (
  filterParams: Array<Record<string, string>>
): Record<string, string> => {
  const finalResult = {} as Record<string, string>;

  filterParams.forEach((param) => {
    Object.keys(param).forEach((key) => {
      if (finalResult[key]) {
        finalResult[key] += `,${param[key]}`;
      } else {
        finalResult[key] = param[key];
      }
    });
  });

  return finalResult;
};

export const convertFilterParamsToQueryObject = (
  filterParams: FilterParams[]
) => {
  const checkedParams = getCheckedFilterParams(filterParams);
  return formatFilterParamsArray(checkedParams);
};

export const capitalize = (str: string) => {
  // Check if the string is empty
  if (str && str.length > 0) {
    // Convert the first character to uppercase and add the rest of the string in lowercase
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  } else {
    // Return the original string if it's empty
    return str;
  }
};
